module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trm-timer"
  }, [(_vm.timeUntil.day >= 0) ? _c('div', {
    staticClass: "trm-timer-val day"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("pad")(_vm.timeUntil.day)))]), _vm._v(" "), _c('span', [_vm._v("day" + _vm._s(_vm.timeUntil.day > 1 ? "s" : ""))])]) : _vm._e(), _vm._v(" "), (_vm.timeUntil.hour >= 0) ? _c('div', {
    staticClass: "trm-timer-val hour"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("pad")(_vm.timeUntil.hour)))]), _vm._v(" "), _c('span', [_vm._v("hour" + _vm._s(_vm.timeUntil.hour > 1 ? "s" : ""))])]) : _vm._e(), _vm._v(" "), (_vm.timeUntil.minute >= 0) ? _c('div', {
    staticClass: "trm-timer-val minute"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("pad")(_vm.timeUntil.minute)))]), _vm._v(" "), _c('span', [_vm._v("min" + _vm._s(_vm.timeUntil.minute > 1 ? "s" : ""))])]) : _vm._e(), _vm._v(" "), (_vm.timeUntil.second >= 0) ? _c('div', {
    staticClass: "trm-timer-val second"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("pad")(_vm.timeUntil.second)))]), _vm._v(" "), _c('span', [_vm._v("sec" + _vm._s(_vm.timeUntil.second > 1 ? "s" : ""))])]) : _c('span', [_vm._v("00:00:00:00")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f4ae66c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/Timer.vue
// module id = 232
// module chunks = 1